import * as i0 from '@angular/core';
import { Directive, HostListener, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

class AlphanumericOnlyDirective {
    constructor(el, renderer) {
        this.el = el;
        this.renderer = renderer;
    }
    onKeyPress(event) {
        return this.validateAlphanumeric(event);
    }
    onKeyDown(event) {
        return this.validateAlphanumeric(event);
    }
    validateAlphanumeric(event) {
        const code = event.keyCode ? event.keyCode : 0;
        if (code === 8 || code === 0) { // 8 - backspace
            return true;
        }
        else if (code === 32) { // white Space
            return true;
        }
        else if (code === 9) { // tab key
            return true;
        }
        else if (code >= 65 && code <= 90) {
            return true;
        }
        else if (code >= 96 && code <= 122) {
            return true;
        }
        else if (code >= 48 && code <= 57) {
            return true;
        }
        else if (event.ctrlKey) {
            // for ctrl + v
            return true;
        }
        else {
            return false;
        }
    }
    blockPaste(event) {
        this.validateFields(event);
    }
    validateFields(event) {
        /*
            Avoid direct DOM updation. better to use Renderer2
            this.el.nativeElement.value.replace(/[^0-9a-zA-Z ]/g, '').replace(/\s/g, '');
          */
        this.renderer.setProperty(this.el.nativeElement, 'value', this.el.nativeElement.value
            .replace(/[^0-9a-zA-Z ]/g, '')
            .replace(/\s/g, ''));
        event.preventDefault();
    }
}
AlphanumericOnlyDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AlphanumericOnlyDirective, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Directive });
AlphanumericOnlyDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.3.12", type: AlphanumericOnlyDirective, selector: "[alphanumericOnly]", host: { listeners: { "keypress": "onKeyPress($event)", "keydown": "onKeyDown($event)", "paste": "blockPaste($event)" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AlphanumericOnlyDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[alphanumericOnly]',
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.Renderer2 }]; }, propDecorators: { onKeyPress: [{
                type: HostListener,
                args: ['keypress', ['$event']]
            }], onKeyDown: [{
                type: HostListener,
                args: ['keydown', ['$event']]
            }], blockPaste: [{
                type: HostListener,
                args: ['paste', ['$event']]
            }] } });

class AlphanumericOnlyModule {
}
AlphanumericOnlyModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AlphanumericOnlyModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
AlphanumericOnlyModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AlphanumericOnlyModule, declarations: [AlphanumericOnlyDirective], exports: [AlphanumericOnlyDirective] });
AlphanumericOnlyModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AlphanumericOnlyModule });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AlphanumericOnlyModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [AlphanumericOnlyDirective],
                    exports: [AlphanumericOnlyDirective],
                }]
        }] });

class NumbersOnlyDirective {
    constructor(el, renderer) {
        this.el = el;
        this.renderer = renderer;
    }
    onKeyPress(event) {
        return this.validateNumbersOnly(event.keyCode);
    }
    onKeyDown(event) {
        return this.validateNumbersOnly(event.keyCode);
    }
    validateNumbersOnly(keyCode) {
        return ((keyCode < 32 && keyCode !== 16 && keyCode !== 38 && keyCode !== 42) || // special chars
            (keyCode >= 48 && keyCode <= 57) || // digits
            (keyCode >= 96 && keyCode <= 105) // numpad digits
        );
    }
    blockPaste(event) {
        this.validateFields(event);
    }
    validateFields(event) {
        /*
            Avoid direct DOM updation. better to use Renderer2
            this.el.nativeElement.value.replace(/[^0-9a-zA-Z ]/g, '').replace(/\s/g, '');
          */
        this.renderer.setProperty(this.el.nativeElement, 'value', this.el.nativeElement.value
            .replace(/[^0-9a-zA-Z ]/g, '')
            .replace(/\s/g, ''));
        event.preventDefault();
    }
}
NumbersOnlyDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: NumbersOnlyDirective, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Directive });
NumbersOnlyDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.3.12", type: NumbersOnlyDirective, selector: "[numbersOnly]", host: { listeners: { "keypress": "onKeyPress($event)", "keydown": "onKeyDown($event)", "paste": "blockPaste($event)" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: NumbersOnlyDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[numbersOnly]',
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.Renderer2 }]; }, propDecorators: { onKeyPress: [{
                type: HostListener,
                args: ['keypress', ['$event']]
            }], onKeyDown: [{
                type: HostListener,
                args: ['keydown', ['$event']]
            }], blockPaste: [{
                type: HostListener,
                args: ['paste', ['$event']]
            }] } });

class NumbersOnlyModule {
}
NumbersOnlyModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: NumbersOnlyModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
NumbersOnlyModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: NumbersOnlyModule, declarations: [NumbersOnlyDirective], exports: [NumbersOnlyDirective] });
NumbersOnlyModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: NumbersOnlyModule });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: NumbersOnlyModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [NumbersOnlyDirective],
                    exports: [NumbersOnlyDirective],
                }]
        }] });

class TrapFocusDirective {
    constructor(elRef) {
        this.elRef = elRef;
        // all the elements inside  to make focusable
        this.focusableElements = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
    }
    onKeydownHandler(e) {
        let isTabPressed = e.key === 'Tab';
        const hostEl = this.elRef.nativeElement;
        if (!this.firstFocusableElement) {
            this.firstFocusableElement = hostEl.querySelectorAll(this.focusableElements)[0]; // get first element to be focused inside host element
        }
        this.focusableContent = hostEl.querySelectorAll(this.focusableElements);
        if (!this.lastFocusableElement) {
            this.lastFocusableElement =
                this.focusableContent[this.focusableContent.length - 1]; // get last element to be focused inside host element
        }
        const found = Array.from(this.focusableContent).find((node) => node.isEqualNode(document.activeElement));
        // Check if the active focus is inside host element
        if (!found) {
            this.firstFocusableElement.focus();
        }
        if (!isTabPressed) {
            return;
        }
        if (e.shiftKey) {
            // if shift key pressed for shift + tab combination
            if (document.activeElement === this.firstFocusableElement) {
                this.lastFocusableElement.focus(); // add focus for the last focusable element
                e.preventDefault();
            }
        }
        else {
            // if tab key is pressed
            if (document.activeElement === this.lastFocusableElement) {
                // if focused has reached to last focusable element then focus first focusable element after pressing tab
                this.firstFocusableElement.focus(); // add focus for the first focusable element
                e.preventDefault();
            }
        }
    }
}
TrapFocusDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: TrapFocusDirective, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive });
TrapFocusDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.3.12", type: TrapFocusDirective, selector: "[trapFocus]", host: { listeners: { "document:keydown": "onKeydownHandler($event)" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: TrapFocusDirective, decorators: [{
            type: Directive,
            args: [{ selector: '[trapFocus]' }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; }, propDecorators: { onKeydownHandler: [{
                type: HostListener,
                args: ['document:keydown', ['$event']]
            }] } });

class TrapFocusDirectiveDirectiveModule {
}
TrapFocusDirectiveDirectiveModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: TrapFocusDirectiveDirectiveModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
TrapFocusDirectiveDirectiveModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: TrapFocusDirectiveDirectiveModule, declarations: [TrapFocusDirective], imports: [CommonModule], exports: [TrapFocusDirective] });
TrapFocusDirectiveDirectiveModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: TrapFocusDirectiveDirectiveModule, imports: [[
            CommonModule
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: TrapFocusDirectiveDirectiveModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [TrapFocusDirective],
                    imports: [
                        CommonModule
                    ],
                    exports: [TrapFocusDirective]
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { AlphanumericOnlyDirective, AlphanumericOnlyModule, NumbersOnlyDirective, NumbersOnlyModule, TrapFocusDirective, TrapFocusDirectiveDirectiveModule };
